var map = {
	"./ArrowDown.svg": "435390e37313de663bc4",
	"./ArrowRight.svg": "0f5d8169d1fdab553778",
	"./Calendar.svg": "fd7b4475e98cd2c92299",
	"./CartDelivery.svg": "5154337f48c892e10c5f",
	"./Catalog.svg": "15b996e43b54ae442692",
	"./Check.svg": "d2addf65e79f05a259d9",
	"./Clients.svg": "aca1a593d38195cfdc7b",
	"./CompanySetup.svg": "eb263c0b0621f86e36cf",
	"./Delete.svg": "a93e5171c08dcb73f3df",
	"./Edit.svg": "0450b8b06278f2512496",
	"./OrdCheck.svg": "0769e9c74ba00490c6c9",
	"./OrdDot.svg": "29359f9c86e565873b60",
	"./OrdX.svg": "b9c2a65156809959eb27",
	"./Orders.svg": "1c57ab8cd2393064a669",
	"./Overview.svg": "8c85bc390a44a7523081",
	"./SupplerMark.svg": "4d6a84478b96e54e1bb8",
	"./noIMG.svg": "4b6dd361de39037ec8a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a1dafefd130b104fd1b";